import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { EMAIL } from "@/data/photos";

const Nav = () => {
  const lenis = useLenis();

  const goToAbout = (e) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo("#about", { offset: -120, duration: 1.6 });
    else document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 z-40 w-full"
    >
      <div className="flex items-baseline justify-between px-6 py-6 md:px-12 bg-[#F5F1EA]/85 backdrop-blur-md">
        <Link
          to="/"
          data-testid="nav-wordmark"
          className="overline-label text-foreground transition-opacity duration-300 hover:opacity-50"
        >
          Anna Kidman
        </Link>
        <nav className="flex items-baseline gap-6 md:gap-10">
          <a
            href="#about"
            onClick={goToAbout}
            data-testid="nav-about-link"
            className="overline-label transition-opacity duration-300 hover:opacity-50"
          >
            About
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="nav-email-link"
            className="overline-label transition-opacity duration-300 hover:opacity-50"
          >
            Email
          </a>
        </nav>
      </div>
    </motion.header>
  );
};

export default Nav;
